export default __webpack_public_path__ + "static/media/leafwalls.606114ec.png";